// Global configuration object - intentionally modifying global scope
// eslint-disable-next-line sonarjs/no-implicit-global
ccmn = { f: { defaultToastDisplayGravity: 'bottom' } };
